<template>
    <div class="flex-1">
        <ListCorrespondences :nodeId="nodeId" />
    </div>
</template>

<script>
    import ListCorrespondences from '@/components/ListCorrespondences.vue';

	export default {
		name: 'SentView',
        components: { ListCorrespondences },
        data () 
        {
            return {
                nodeId: 66,
            }
        },
	}
</script>